module.exports = __webpack_public_path__ + "static/media/doctor-disabled.ce838801.svg";